import { Outlet } from "react-router-dom";
import { usePageTitle } from "../templates/hooks/UsePageTitleHook";

export function AppLayout(): JSX.Element {
  usePageTitle();
  
  return <Outlet />;
}
